import {
  Box,
  FieldLabel,
  FieldMessage,
  Stack,
  Text,
  TextField,
  useResponsiveValue,
} from 'braid-design-system';

interface TextFieldValue {
  seekId: string;
  name: string;
}

interface Props {
  customersLength: number;
  error: boolean;
  id: string;
  onChange: (value: TextFieldValue[]) => void;
  rawValue: TextFieldValue[] | string;
}

export const LargestCustomers = ({
  customersLength,
  error,
  id,
  onChange,
  rawValue,
}: Props) => {
  const value = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
  const size = customersLength > 5 ? 5 : customersLength;

  value.splice(size, value.length);

  const set = (
    rowNum: number,
    prop: keyof TextFieldValue,
    newValue: string,
  ) => {
    const copy = [...value];
    copy[rowNum] = { ...copy[rowNum], [prop]: newValue };
    onChange(copy);
  };

  const responsiveValue = useResponsiveValue();
  const isMobile = responsiveValue({
    mobile: true,
    tablet: false,
    desktop: false,
  });

  return (
    <>
      <FieldLabel
        htmlFor="largestCustomers"
        label={`Please list your ${size} largest SEEK customer${
          size > 1 ? 's' : ''
        }`}
      />
      <Box paddingTop="gutter">
        <Stack space="small">
          <Box
            id={id}
            paddingX="gutter"
            borderRadius="standard"
            boxShadow={error ? 'borderCritical' : undefined}
            paddingY={error ? 'gutter' : 'none'}
          >
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>
                    <Text align="left">SEEK Account ID</Text>
                  </th>
                  <th>
                    <Text align="left">Account Name</Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...Array(size)].map((_, key) => (
                  <tr key={key}>
                    <td width={isMobile ? '' : '180'}>
                      <TextField
                        key={key}
                        id={`largestCustomers-${key}-seekId`}
                        label=""
                        onClear={() => set(key, 'seekId', '')}
                        onChange={({ currentTarget: { value: newValue } }) => {
                          set(key, 'seekId', newValue);
                        }}
                        value={value[key]?.seekId || ''}
                      />
                    </td>
                    <td>
                      <TextField
                        key={key}
                        id={`largestCustomers-${key}-name`}
                        label=""
                        onClear={() => set(key, 'name', '')}
                        onChange={({ currentTarget: { value: newValue } }) =>
                          set(key, 'name', newValue)
                        }
                        value={value[key]?.name || ''}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {error ? (
              <Box paddingTop="medium">
                <FieldMessage
                  id={id}
                  message="Required Field"
                  tone="critical"
                />
              </Box>
            ) : null}
          </Box>
        </Stack>
      </Box>
    </>
  );
};
